import Class from '../class.js';
import Matreshka from '../matreshka/index.js';
import instanceMembers from './_prototype.js';
import matreshkaError from '../_helpers/matreshkaerror.js';
import initMK from '../_core/init.js';
instanceMembers.extends = Matreshka;
instanceMembers.constructor = function MatreshkaObject(data) {
  if (!(this instanceof MatreshkaObject)) {
    throw matreshkaError('common:call_class');
  }
  initMK(this);
  // return is used to make possible to chain super() calls
  return typeof data !== 'undefined' ? this.setData(data) : this;
};
var MatreshkaObject = Class(instanceMembers);
// the value and the instance type under one name
export { MatreshkaObject as default };